import Home from "./component/Home";
import Nav from "./component/Nav";
import About from "./component/About";
import Service from "./component/Service";
import UpaArrow from "./component/UpaArrow";
import Resume from "./component/Resume";
import Portfolio from "./component/Portfolio";
import Contact from "./component/Contact";
import Footer from "./component/Footer";

import './App.css'
function App() {
  return <>

    <Nav/>
    <Home/>
    <About/>
    <Service/>
    <Resume/>
    <Portfolio/>
    <Contact/>
    <Footer/>
    <UpaArrow/>
    

 
  </>


  
}

export default App;
